<template>
    <div>
        <div class="messages" v-if="messages.length > 0">
            <span class="folder is-sanserif is-smaller-font is-dark-grey is-bolder is-full-width">{{$route.params.folder.toUpperCase()}}</span>
            <router-link :to="'/f/' + $route.params.folder + '/' + message.id" v-for="message in messages" :key="message.key" class="message is-no-decoration">
                <!-- eslint-disable -->
                <span class="from is-serif is-smaller-font is-boldest is-darker-grey">{{message.from.replace(/(.*)\s<.*>/, '$1')}}</span>
                <!-- eslint-enable -->
                <span class="subject is-sanserif is-smaller-font is-bold is-dark-grey">{{message.subject}}</span>
                <span class="snippet is-sanserif is-smallest-font is-light is-light-grey">{{decodeHTMLEntities(message.snippet)}}</span>
                <span class="date is-sanserif is-smallest-font is-bold is-dark-grey">{{new Date(message.date).toLocaleDateString('us-EN', { weekday: 'short', month:'long', year:'numeric', day: 'numeric' })}} at {{new Date(message.date).toLocaleTimeString('us-EN', { hour: 'numeric', minute:'numeric'})}}</span>
            </router-link>
        </div>
        <div class="viewer" v-if="viewer">
            <div class="info">
                <span class="subject is-medium-font is-dark-grey is-serif is-full-width is-bold">{{viewer.subject}}</span>
                <span class="to is-smallest-font is-grey is-sanserif is-full-width is-bold">To: {{viewer.to}}</span>
                <span class="from is-smallest-font is-grey is-sanserif is-full-width is-bold">From: {{viewer.from}}</span>
            </div>
            <!-- eslint-disable -->
            <iframe class="frame" :srcdoc="'<meta http-equiv=\'Content-Type\' content=\'text/html; charset=utf-8\'><meta charset=\'utf-8\'><style>body{font:14px/1.4 \'Open Sans\',sans-serif}body {padding:20px;}</style>' + (isHTML(viewer.body) ? viewer.body : viewer.body.replace(/\n/g, '<br>'))" />
            <!-- eslint-enable -->
        </div>
        <div class="not-found is-biggest-font is-lightest-grey is-serif is-bold" v-if="messages.length < 1">
            <span>Nothing to see here... Try a different folder.</span>
        </div>
    </div>
</template>

<script>
    export default {
        async beforeCreate() {
            this.messages =  await this.$gmail.messages.getByLabels([this.$route.params.folder.toUpperCase()]);
            this.viewer = this.$route.params.message ? this.messages.find(item => item.id === this.$route.params.message) : this.messages[0];
            console.log(this.messages)
        },
        watch: {
            '$route.params.folder': async function (folder) {
                this.messages = await this.$gmail.messages.getByLabels([folder.toUpperCase()]);
                this.viewer = this.messages[0];
            },
            '$route.params.message': async function (message) {
                this.viewer = message ? this.messages.find(item => item.id === message) : this.messages[0];
            }
        },
        methods: {
            decodeHTMLEntities (str) {
                const txt = document.createElement("textarea");
                txt.innerHTML = str;
                return txt.value.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/"/g, "&quot;");
            },
            isHTML(str) {
                let doc = new DOMParser().parseFromString(str, "text/html");
                return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
            }
        },
        data() {
            return {
                messages: [],
                viewer:null,
            }
        }
    }
</script>